import React from 'react';
import { FaStar } from 'react-icons/fa';

const reviews = [
  {
    name: "Ashesh Banerjee",
    institution: "VIT, CSE",
    rating: 5,
    quote: "To anyone considering a training with Internselite, I wholeheartedly recommend it. It's not just a learning experience; it's an investment in your growth and development."
  },
  {
    name: "Hitesh Kunar",
    institution: "NIT, Kurukshetra, Haryana And MCA",
    rating: 5,
    quote: "The program was extremely good and outstanding. I would like to highlight the key takeaways from this training and internship like the guide provided by our mentors, going in depth into Data Science and Machine Learning, discussing real-life problems, and providing skills development classes."
  },
  {
    name: "Rajula Aurshitha Reddy",
    institution: "Sir Padampat Singhania University, BTech CSE",
    rating: 4,
    quote: "I am truly grateful for this wonderful opportunity and the invaluable guidance I've received. It has been an enlightening experience that has not only enhanced my skills but also enriched my understanding of these technologies."
  },
  {
    name: "Jashika Yadav",
    institution: "Shyama Prasad Mukherjee College- Bachelors of Commerce",
    rating: 5,
    quote: "The classes were fun yet knowledgeable. The projects given were good too. The skill development classes were great, and I learned very valuable things from them. Both the teachers and staff were very helpful and keen to solve my doubts as quickly as possible. Overall, my experience was great."
  },
  {
    name: "Yadnyavalkya Kailas Dakhore",
    institution: "Babasaheb Naik College of Engineering Pusad, CSE",
    rating: 4,
    quote: "It was an amazing journey with InternsElite. I am glad to have had such a great time with the training and classes with the InternsElite team. This will help me a lot in my future, so I am very thankful to InternsElite and the team."
  },
  {
    name: "Vedant Vishal Trivedi",
    institution: "SNJB'S College of Engineering, CS",
    rating: 5,
    quote: "Complete training was really good and I got to learn many things. Also, the soft skills sessions were really helpful in building a successful career."
  }
];

function DS_Review_Program_Page() {
  return (
    <div>
      <div className='container'>
        <div className='row d-sm-block d-md-none'>
          <div className='col-md-1'></div>
          <div className='col-md-10'>
            <div className='text-center review_component_text'>
              <h2 className='display-5 pb-2'>Testmonial</h2>
              <p className='fs-6'>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
            </div>
          </div>
          <div className='col-md-1'></div>
        </div>
        <div className='row'>
          <div className='col-md-4 pt-5'>
            <div className='Program_review_comp'>
              <div className='mt-5 px-5 review_component_text'>
                <h2 className='pt-5 display-6'>Hear What Our Students Say</h2>
                <p className='pt-4 fs-5'>25K+ Students have already learned with InternsElite</p>
              </div>
            </div>
          </div>
          <div className='col-md-8'>
            <div className='row'>
              {reviews.map((review, index) => (
                <div key={index} className={`col-md-${index % 2 === 0 ? 5 : 7} card`}>
                  <div className='card-body'>
                    <h5 className='font-weight-bold Review_not_copy'>{review.name}</h5>
                    <h6 className='font-weight-bold my-2 Review_not_copy'>{review.institution}</h6>
                    <ul className='list-unstyled d-flex justify-content-start Review_not_copy'>
                      {Array.from({ length: 5 }, (_, i) => (
                        <li key={i}>
                          <FaStar color={i < review.rating ? "gold" : "#e0e0e0"} />
                        </li>
                      ))}
                    </ul>
                    <p className="Review_not_copy">
                      <i className="fas fa-quote-left pe-2"></i>{review.quote}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DS_Review_Program_Page;
